import useUserType from "../../hooks/useUserType";
import localeText from "../../locale";
import { canEarnShareCommission, formatPercent, getShareCommissionPercent } from "./promoterShare";

// Selo do card no marketplace: aparece só para Promoter logado.
export default function PromoterCommissionBadge({ product, style }) {
  const { userType } = useUserType();

  if (!canEarnShareCommission(userType, product)) return null;

  const percent = formatPercent(getShareCommissionPercent(product));

  return (
    <span
      title={localeText("promoterBadgeTitle", { percent })}
      className="inline-flex align-items-center gap-1 font-semibold border-round"
      style={{
        backgroundColor: "#ECFDF5",
        color: "#047857",
        border: "1px solid #A7F3D0",
        fontSize: "11px",
        lineHeight: 1,
        padding: "4px 6px",
        ...style,
      }}
    >
      <i className="pi pi-share-alt" style={{ fontSize: "10px" }} />
      {localeText("promoterBadge", { percent })}
    </span>
  );
}
